"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var typestyle_1 = require("typestyle");
__export(require("./colors"));
__export(require("./typography"));
// a couple of simple helper functions that mean we can centralise our rules
// for what we consider to be a desktop vs a mobile browser
exports.forDesktop = function () {
    var objects = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        objects[_i] = arguments[_i];
    }
    return typestyle_1.media.apply(void 0, __spreadArrays([{ minWidth: 900 }], objects));
};
exports.forMobile = function () {
    var objects = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        objects[_i] = arguments[_i];
    }
    return typestyle_1.media.apply(void 0, __spreadArrays([{ maxWidth: 899 }], objects));
};
exports.hideOnMobile = typestyle_1.style(exports.forMobile({ display: 'none' }));
var kGapValue = 1.875;
exports.kGap = kGapValue + "rem";
exports.kHalfGap = kGapValue / 2 + "rem";
exports.kQuarterGap = kGapValue / 4 + "rem";
exports.kVertSpace = '0.5rem';
exports.kMidBase = '2.5rem';
exports.kBase = '4rem';
exports.kBorderRadius = '2';
